import * as React from 'react';
type Props = {
  className?: string;
};
export function Flame({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-flame"
      className={className}
    >
      <mask
        id="mask0_21_1557"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_21_1557)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.3683 3.07028L10.2089 2.21472L11.0715 4.37137C11.1396 4.5415 11.2496 4.86116 11.3609 5.27453C11.5323 5.91096 11.6392 6.54052 11.6518 7.10861C11.6761 8.19879 11.3768 8.82028 10.6838 9.05129C9.7986 9.34635 8.57297 8.89691 7.8927 7.54933L7.26999 6.31577L6.29289 7.29287C5.98335 7.60241 5.55342 8.14221 5.12974 8.89071C4.42492 10.1359 4 11.5381 4 13.0666C4 17.6112 7.50426 21 12 21C16.4161 21 20 17.4503 20 13.0666C20 8.40847 17.723 5.19174 12.3683 3.07028ZM13.523 5.80198L13.6596 5.8766C16.7646 7.60042 18 9.86657 18 13.0666C18 16.3414 15.3158 19 12 19C8.59411 19 6 16.4914 6 13.0666L6.00798 12.7537C6.06092 11.7177 6.37464 10.7515 6.87026 9.87591L6.974 9.69998L7.1095 9.84023C8.31849 11.0337 9.95337 11.4029 11.3162 10.9487C12.9936 10.3896 13.6929 8.93697 13.6513 7.06418C13.643 6.68968 13.6057 6.30715 13.5442 5.92081L13.523 5.80198Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
